import React from "react";
import "./Privacy.css";
import logo from "../assets/images/logo_cyber_112.png";

const Privacy = () => {
  return (
    <div className="privacy-container-1">
      <div className="privacy-content">
        <img src={logo} alt="Cyber112 Logo" className="privacy-logo" />
        <h2 className="privacy-title">Politika privatnosti</h2>

        <div className="privacy-section">
          <h3>1. Uvod</h3>
          <p>
            Dobrodošli u Cyber112! Mi smo posvećeni zaštiti vaših prava na privatnost i zato smo kreirali ovu Politiku privatnosti ("Politika"). 
            Ova Politika opisuje kako prikupljamo, koristimo i štitimo vaše lične podatke kada koristite našu Cyber112 mobilnu aplikaciju ("Aplikacija").
          </p>
        </div>

        <div className="privacy-section">
          <h3>2. Prikupljanje informacija</h3>
          <p>
            Prikupljamo informacije koje nam dobrovoljno pružite pri registraciji, kao što su ime, prezime, e-mail i broj telefona. 
            Takođe prikupljamo tehničke podatke o uređaju i korištenju aplikacije.
          </p>
        </div>

        <div className="privacy-section">
          <h3>3. Korištenje informacija</h3>
          <p>
            Koristimo prikupljene informacije kako bismo pružili usluge, unaprijedili aplikaciju, komunicirali s vama i osigurali sigurnost sistema.
          </p>
        </div>

        <div className="privacy-section">
          <h3>4. Dijeljenje informacija</h3>
          <p>
            Ne prodajemo vaše podatke. Možemo ih dijeliti s partnerima radi pružanja usluga ili ako je zakonski obavezno.
          </p>
        </div>

        <div className="privacy-section">
          <h3>5. Sigurnost</h3>
          <p>
            Primjenjujemo tehničke i administrativne mjere zaštite da bismo spriječili neovlašten pristup ili zloupotrebu podataka.
          </p>
        </div>

        <div className="privacy-section">
          <h3>6. Vaša prava</h3>
          <p>
            Imate pravo na pristup, ispravku, brisanje i ograničenje obrade podataka, kao i pravo na prenosivost podataka.
          </p>
        </div>

        <h2 className="privacy-title">Uslovi korištenja</h2>

        <div className="privacy-section">
          <h3>1. Prihvaćanje uslova</h3>
          <p>Korištenjem aplikacije prihvatate ove uslove. Ako se ne slažete, nemojte koristiti aplikaciju.</p>
        </div>

        <div className="privacy-section">
          <h3>2. Intelektualna svojina</h3>
          <p>Sav sadržaj u aplikaciji je naše vlasništvo i zaštićen autorskim pravima.</p>
        </div>

        <div className="privacy-section">
          <h3>3. Korištenje aplikacije</h3>
          <p>Ne smijete koristiti aplikaciju za nezakonite svrhe ili narušavanje sigurnosti sistema.</p>
        </div>

        <div className="privacy-section">
          <h3>4. Ograničenje odgovornosti</h3>
          <p>Nismo odgovorni za štetu nastalu korištenjem aplikacije, osim u slučaju namjerne pogreške.</p>
        </div>

        <div className="privacy-section">
          <h3>5. Promjene uslova</h3>
          <p>Zadržavamo pravo da povremeno mijenjamo ovu politiku i uslove.</p>
        </div>

        <div className="privacy-section">
          <h3>Kontakt</h3>
          <p>
            Ako imate pitanja, kontaktirajte nas na{" "}
            <a href="mailto:info@cyber112.org">info@cyber112.org</a>.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Privacy;